import axios from 'axios';

import { setAlert } from './alert';
import { changeLoader } from './loader';

const descargar = (blob, nombre) => {
    const url  = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href  = url;
    link.setAttribute('download', nombre);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};

export const generarReporteVentasProducto = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' }, responseType: 'blob' };
    const body   = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/ventas-por-producto`, body, config);
        const file = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        descargar(file, 'Reporte_ventas_por_producto.xlsx');
        await dispatch(setAlert('Reporte generado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const generarReporteVentasEmpleado = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' }, responseType: 'blob' };
    const body   = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/ventas-por-empleado`, body, config);
        const file = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        descargar(file, 'Reporte_ventas_por_empleado.xlsx');
        await dispatch(setAlert('Reporte generado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const generarReporteGastos = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' }, responseType: 'blob' };
    const body   = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/gastos`, body, config);
        const file = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        descargar(file, 'Reporte_gastos.xlsx');
        await dispatch(setAlert('Reporte generado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const generarReporteNomina = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' }, responseType: 'blob' };
    const body   = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/nomina`, body, config);
        const file = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        descargar(file, 'Reporte_nomina.xlsx');
        await dispatch(setAlert('Reporte generado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const generarReporteSucursales = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' }, responseType: 'blob' };
    const body   = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/resumen-sucursales`, body, config);
        const file = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        descargar(file, 'Reporte_resumen_sucursales.xlsx');
        await dispatch(setAlert('Reporte generado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};

export const generarReporteEventos = (filtros = {}) => async dispatch => {
    const config = { headers: { 'Content-Type': 'application/json' }, responseType: 'blob' };
    const body   = JSON.stringify(filtros);

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/reportes/resumen-eventos`, body, config);
        const file = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        descargar(file, 'Reporte_resumen_eventos.xlsx');
        await dispatch(setAlert('Reporte generado correctamente', 'success'));
    } catch (error) {
        if (error?.response?.data?.msg) {
            await dispatch(setAlert(error.response.data.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
};
